import browse from './browse.vue';
import form from './form.vue';
import permissions from './permissions';
import read from './read.vue';
import roles from './roles';
import securables from './securables';

export default { browse, create: form, read, edit: form, permissions, roles, securables };
